import { Box } from '@mui/material';
import React, { useState, type MouseEvent } from 'react';
import { VerticalSeparator } from '../../common/components/DelimitedLabels';
import EllipsisText from '../../common/components/EllipsisText';
import { PUNCTUATION_MARKS_CONSTANTS } from '../../common/constants/constants';
import ResponsiveLayout from '../../common/ResponsiveLayout';
import { hyperlinkSx } from '../../common/utils/commonUtils';
import type { PersonRolesMap } from '../types';
import { OWNER_ITEM_WRAPPER_SX, OWNER_RESPONSIVE_LAYOUT_SX, OWNER_TILE_WIDTH } from './projectOwnerConstants';

const ownerNameSx = { minWidth: 0, maxWidth: '100%', flex: 1 };
const ownerNameLinkSx = { ...hyperlinkSx, minWidth: 0, maxWidth: '100%', flex: 1 };

type RenderPeopleByNameProps = {
    peopleGroupedByName: PersonRolesMap[];
    onPersonClick?: (event: MouseEvent<HTMLButtonElement>, personId?: string) => void;
};

function RenderPeopleByName({ peopleGroupedByName, onPersonClick }: RenderPeopleByNameProps) {
    const [lastVisibleIndex, setLastVisibleIndex] = useState<number | undefined>();

    return (
        <ResponsiveLayout
            gap={1.5}
            sx={OWNER_RESPONSIVE_LAYOUT_SX}
            tileWidth={OWNER_TILE_WIDTH}
            setLastElementToFitIndex={setLastVisibleIndex}
        >
            {peopleGroupedByName.map((person, index) => {
                const {
                    person: { name, id },
                    roles
                } = person;

                const labelText =
                    roles.length > 0
                        ? `${PUNCTUATION_MARKS_CONSTANTS.colon} ${roles.join(PUNCTUATION_MARKS_CONSTANTS.comma)}`
                        : `${PUNCTUATION_MARKS_CONSTANTS.colon} ${PUNCTUATION_MARKS_CONSTANTS.dash}`;

                const lastVisible = lastVisibleIndex ?? peopleGroupedByName.length - 1;
                const showSeparator = index < peopleGroupedByName.length - 1 && index < lastVisible;

                return (
                    <Box key={id || index} sx={OWNER_ITEM_WRAPPER_SX}>
                        <EllipsisText
                            sx={id ? ownerNameLinkSx : ownerNameSx}
                            onClick={(event: React.MouseEvent<HTMLButtonElement>) => onPersonClick?.(event, id)}
                            text={name + labelText}
                        />
                        {showSeparator && <VerticalSeparator />}
                    </Box>
                );
            })}
        </ResponsiveLayout>
    );
}

export default RenderPeopleByName;
